import { render, staticRenderFns } from "./PuzzlePage.vue?vue&type=template&id=33a2082a&scoped=true"
import script from "./PuzzlePage.vue?vue&type=script&lang=js"
export * from "./PuzzlePage.vue?vue&type=script&lang=js"
import style0 from "./PuzzlePage.vue?vue&type=style&index=0&id=33a2082a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a2082a",
  null
  
)

export default component.exports